/** @format */

import React from "react";
import styled from "styled-components";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

// import pic from "../Images/sign-up.svg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { User as Consultant } from "../Global/ReduxState";
import { loginspecialist } from "../Api/Api";
import { AnyAction } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import DatasIsaLoading from "../Home/Loading/DatasIsaLoading";
import { UseAppDispach } from "../Global/Store";

const ConsultantSignin = () => {
  const dispatch = UseAppDispach();
  const navigate = useNavigate();

  const schema = yup
    .object({
      email: yup.string().required("Please, input your email"),
      password: yup.string().required("Please, input your password"),
    })
    .required();

  type formData = yup.InferType<typeof schema>;

  const posting = useMutation({
    mutationKey: ["lifecareUser"],
    mutationFn: loginspecialist,

    onSuccess: (myData: any) => {
      dispatch(Consultant(myData.data));

      if (myData.data) {
        Swal.fire({
          title: "Signed in successfully",
          text: "Welcome!",
          timer: 3000,
          icon: "success",
          timerProgressBar: true,
          willClose: () => {
            window.location.reload();
          },
        });
        // navigate("/consulthome", { replace: true });
      } else if (myData.message === "Network Error") {
        Swal.fire({
          icon: "error",
          title: `${myData.message}`,
          text: "Please Check Your Internet Connection",
        });

        // Swal.fire(
        //   `${data.message}`,
        //   "Please Check Your Internet Connection",
        //   "question"
        // );
      } else {
        Swal.fire({
          icon: "error",
          title: `Something Went Wrong`,
          text: `${myData.response.data.err} ❌❌`,
        });
      }
    },
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
    register,
  } = useForm<formData>({
    resolver: yupResolver(schema),
  });

  const Submit = handleSubmit(async (data) => {
    posting.mutate(data);
  });

  const [showPassword, setshowPassword] = React.useState(false);

  const fn = () => [setshowPassword(!showPassword)];

  return (
    <>
      <Body>
        {/* <Black></Black> */}

        <Hold>
          <Right>
            <RightImg src={"pic"} />
          </Right>

          <Left>
            <Form onSubmit={Submit}>
              <div
                style={{
                  fontSize: "20px",
                  color: "#8A2BE2",
                  fontWeight: "700",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                consultant Sign in
              </div>

              <Input type="text" placeholder="Email" {...register("email")} />
              <p>{errors?.email && errors?.email?.message}</p>
              <Wrap>
                <Input
                  style={{
                    height: "100%",
                    boxShadow: "none",
                    width: "100%",
                    borderBottom: "none",
                  }}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  {...register("password")}
                />
                {showPassword ? (
                  <Icon onClick={fn}>
                    <AiOutlineEye />
                  </Icon>
                ) : (
                  <Icon onClick={fn}>
                    <AiOutlineEyeInvisible />
                  </Icon>
                )}
              </Wrap>
              <p>{errors?.password && errors?.password?.message}</p>

              {posting.isLoading ? (
                <>
                  <DatasIsaLoading />
                </>
              ) : (
                <Button type="submit">Sign in</Button>
              )}

              <Link style={{ textDecoration: "none" }} to={""}>
                <Already>Forgot Password?</Already>
              </Link>

              <Link style={{ textDecoration: "none" }} to={"/signup"}>
                <Already>Already have an account? Sign up</Already>
              </Link>
            </Form>
          </Left>
        </Hold>
      </Body>
    </>
  );
};

export default ConsultantSignin;

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 2px #8a2be2;
  height: 45px;
  border-radius: 7px;
  width: 280px;

  @media screen and (max-width: 500px) {
    box-shadow: none;
    border-bottom: 1px solid #8a2be2;
  }

  @media screen and (max-width: 768px) {
    width: 280px;
    height: 35px;
  }
`;

const Icon = styled.div`
  color: #8a2be2;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 3px;
  font-size: 18px;
  margin-right: 5px;
`;

const RightImg = styled.img`
  width: 500px;
  color: #518f00;
`;

const Right = styled.div`
  width: 50%;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const Already = styled.div`
  font-size: 13px;
  cursor: pointer;
  color: #6c63ff;
  margin-top: 15px;
  text-align: center;

  @media screen and (max-width: 425px) {
    font-size: 10px;
  }
`;

const Button = styled.button`
  width: 105%;
  height: 40px;
  background: #8a2be2;
  color: white;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  transition: all 350ms;
  :hover {
    background-color: transparent;
    border: 1px solid #8a2be2;
    color: #8a2be2;
    transform: scale(0.97);
  }
`;

const Input = styled.input`
  width: 100%;
  height: 40px;
  border: none;
  box-shadow: 0 0 2px #8a2be2;
  border-radius: 7px;
  padding-left: 10px;
  outline: none;
  background-color: transparent;

  @media screen and (max-width: 425px) {
    box-shadow: none;
    border-bottom: 1px solid #8a2be2;
  }

  @media screen and (max-width: 768px) {
    height: 35px;
  }
`;

const Form = styled.form`
  width: 270px;
  height: 320px;
  box-shadow: 0 0 3px #8a2be2;
  border-radius: 10px 0 10px 0;
  padding: 30px;
  padding-right: 40px;

  p {
    font-size: 10px;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 425px) {
    width: 310px;
    padding: 20px;
    padding-right: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: none;
  }
  @media screen and (max-width: 320px) {
    width: 310px;
    padding: 10px;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const Left = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    width: 85%;
  }
  @media screen and (max-width: 425px) {
    width: 95%;
  }
`;

const Hold = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const Body = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
